import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedParticipanteRoute({ children }) {
  const { isAuthenticated, token, usuario, tipoUsuario, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) return null;

  const allowed =
    isAuthenticated &&
    !!token &&
    !!usuario &&
    tipoUsuario === 'participante';

  if (!allowed) {
    // Detecta se veio de /res/:idTurma ou /ead/:idTurma
    const match = (location.pathname || '').match(/^\/(res|ead)\/([^/?#]+)/i);
    const dest = match?.[1]?.toLowerCase() || '';
    const turma = match?.[2] || '';

    // Se for res/ead, também manda query para fallback (caso state se perca)
    const searchParams =
      turma && (dest === 'res' || dest === 'ead')
        ? `?turma=${encodeURIComponent(turma)}&dest=${encodeURIComponent(dest)}`
        : '';

    return (
      <Navigate
        to={{ pathname: '/participante/login', search: searchParams }}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}

export default ProtectedParticipanteRoute;